<template>
    <div class="section-con">
        <section-title :main="main" :sub="sub"></section-title>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        main: {
            type: String,
            default: ''
        },
        sub: {
            type: String,
            default: ''
        },
    }
}
</script>